import React, { createContext, useContext, useState, useCallback } from 'react';

import { trackError } from 'backend-client-web';
import { FallbackComponent } from 'client-web-sdk';

import FullscreenFrame from 'src/components/FullscreenFrame';

export interface DisplayErrorContextValue {
  displayError: (e: unknown) => void;
}

const DisplayErrorContext = createContext<DisplayErrorContextValue>({
  displayError: trackError,
});

export function DisplayErrorContextProvider({ children }: React.PropsWithChildren<{}>) {
  const [error, setError] = useState<unknown>();

  const displayError = useCallback((e: unknown) => {
    trackError(e);
    setError(e);
  }, []);

  return (
    <DisplayErrorContext.Provider value={{ displayError }}>
      {error ?
        <FullscreenFrame>
          <FallbackComponent error={error} />
        </FullscreenFrame>
      : children}
    </DisplayErrorContext.Provider>
  );
}

export function useDisplayErrorContext() {
  return useContext(DisplayErrorContext);
}
